<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="$store.state.stocks.stocks"
      class="elevation-1"
    >
      <template v-slot:[`item.action`]="{ item }">
        <router-link
          :to="{
            name: 'Editare stoc',
            params: { productId: $route.params.productId, stockId: item.id },
          }"
        >
          <v-icon class="mr-2">edit</v-icon>
        </router-link>
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
      <router-link
        :to="{
          name: 'Adaugare stoc',
          params: { productId: $route.params.productId },
        }"
      >
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'ListStocks',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Cantitate',
          align: 'center',
          value: 'quantity',
          sortable: true,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],

      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.getStocks(this.$route.params.productId);
  },
  methods: {
    ...mapActions('stocks', ['getStocks', 'delete']),
    editItem(item) {
      const { id } = item;
      this.$router.push({ name: 'Editare stoc', params: { id } });
    },
    async deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        await this.delete({
          productId: this.$route.params.productId,
          stockId: item.id,
        });
      }
    },
  },
};
</script>
